export abstract class SharedAnalyticsService {
  abstract trackEvent(
    action: string,
    label?: string,
    customDimension?: any,
    categorySuffix?: string
  ): void;
}
